// extracted by mini-css-extract-plugin
export var brand = "_6w-9";
export var compact = "_6w-6";
export var extraSmall = "_6w-7";
export var icon = "_6w-0";
export var large = "_6w-4";
export var light = "_6w-1";
export var medium = "_6w-5";
export var outline = "_6w-b";
export var primaryDark = "_6w-a";
export var primaryLight = "_6w-8";
export var primaryModern = "_6w-c";
export var success = "_6w-2";
export var successSolid = "_6w-3";